
export const diag_code_ids = [
  // AUDIO
  {
    category: 'diag_audio',
    test: 'internal_speaker',
    id: '20'
  },
  {
    category: 'diag_audio',
    test: 'internal_microphone',
    id: '21'
  },
  {
    category: 'diag_audio',
    test: 'output_jack',
    id: '22'
  },
  {
    category: 'diag_audio',
    test: 'input_jack',
    id: '23'
  },
  {
    category: 'diag_audio',
    test: 'combo_jack',
    id: '24'
  },
  {
    category: 'diag_audio',
    test: 'apple_audio_test',
    id: '29'
  },

  // BATTERY
  {
    category: 'diag_battery',
    test: 'battery_wear_level',
    id: '1'
  },
  {
    category: 'diag_battery',
    test: 'battery_charging_test',
    id: '2'
  },
  {
    category: 'diag_battery',
    test: 'battery_drain_test',
    id: '3'
  },
  {
    category: 'diag_battery',
    test: 'apple_battery_test',
    id: '9'
  },

  // CPU
  {
    category: 'diag_cpu',
    test: 'full_test',
    id: '500'
  },
  {
    category: 'diag_cpu',
    test: 'general_purpose_instructions',
    id: '501'
  },
  {
    category: 'diag_cpu',
    test: 'floating_point_unit_instructions',
    id: '502'
  },
  {
    category: 'diag_cpu',
    test: 'prime_number_test',
    id: '503'
  },
  {
    category: 'diag_cpu',
    test: 'maximum_heat',
    id: '504'
  },
  {
    category: 'diag_cpu',
    test: 'mmx',
    id: '505'
  },
  {
    category: 'diag_cpu',
    test: 'sse',
    id: '506'
  },
  {
    category: 'diag_cpu',
    test: 'sse2',
    id: '507'
  },
  {
    category: 'diag_cpu',
    test: 'sse3',
    id: '508'
  },
  {
    category: 'diag_cpu',
    test: 'aes',
    id: '509'
  },
  {
    category: 'diag_cpu',
    test: 'sse41',
    id: '510'
  },
  {
    category: 'diag_cpu',
    test: 'sse42',
    id: '511'
  },
  {
    category: 'diag_cpu',
    test: 'sse4a',
    id: '512'
  },
  {
    category: 'diag_cpu',
    test: 'avx',
    id: '513'
  },
  {
    category: 'diag_cpu',
    test: 'fma3',
    id: '514'
  },
  {
    category: 'diag_cpu',
    test: 'apple_cpu_test',
    id: '519'
  },

  // MAINBOARD
  {
    category: 'diag_mainboard',
    test: 'usb_ports',
    id: '120'
  },
  {
    category: 'diag_mainboard',
    test: 'apple_usb_test',
    id: '128'
  },
  {
    category: 'diag_mainboard',
    test: 'apple_thunderbolt_test',
    id: '129'
  },

  // MEMORY
  {
    category: 'diag_memory',
    test: 'ram',
    id: '540'
  },
  {
    category: 'diag_memory',
    test: 'ram_multi_process_torture',
    id: '541'
  },
  {
    category: 'diag_memory',
    test: 'apple_memory_test',
    id: '549'
  },

  // NETWORK
  {
    category: 'diag_network',
    test: 'wired_lan',
    id: '50'
  },
  {
    category: 'diag_network',
    test: 'wifi_wan',
    id: '51'
  },
  {
    category: 'diag_network',
    test: 'apple_wired',
    id: '57'
  },
  {
    category: 'diag_network',
    test: 'apple_wifi',
    id: '58'
  },
  {
    category: 'diag_network',
    test: 'apple_bluetooth',
    id: '59'
  },

  // OTHER
  {
    category: 'diag_other',
    test: 'card_reader',
    id: '70'
  },
  {
    category: 'diag_other',
    test: 'apple_card_reader',
    id: '79'
  },
  {
    category: 'diag_other',
    test: 'suspend_mode_test',
    id: '110'
  },
  {
    category: 'diag_other',
    test: 'webcam',
    id: '140'
  },
  {
    category: 'diag_other',
    test: 'apple_webcam',
    id: '149'
  },
  {
    category: 'diag_other',
    test: 'apple_case_handle_test',
    id: '491'
  },
  {
    category: 'diag_other',
    test: 'apple_serial_number_test',
    id: '492'
  },
  {
    category: 'diag_other',
    test: 'apple_smc_test',
    id: '493'
  },
  {
    category: 'diag_other',
    test: 'apple_firmware_test',
    id: '494'
  },
  {
    category: 'diag_other',
    test: 'apple_fan_test',
    id: '495'
  },
  {
    category: 'diag_other',
    test: 'apple_power_management_test',
    id: '496'
  },
  {
    category: 'diag_other',
    test: 'apple_power_adapter_test',
    id: '497'
  },
  {
    category: 'diag_other',
    test: 'apple_io_card',
    id: '498'
  },
  {
    category: 'diag_other',
    test: 'apple_antenna_connector_board_test',
    id: '499'
  },
  {
    category: 'diag_other',
    test: 'quick_test',
    id: '580'
  },

   // SCREEN
   {
    category: 'diag_screen',
    test: 'display_ports',
    id: '80'
  },
  {
    category: 'diag_screen',
    test: 'apple_hdmi_controller_test',
    id: '89'
  },
  {
    category: 'diag_screen',
    test: 'dead_pixel_test',
    id: '100'
  },
  {
    category: 'diag_screen',
    test: 'screen_calibration_test',
    id: '101'
  },
  {
    category: 'diag_screen',
    test: 'touchscreen',
    id: '132'
  },

  // SENSORS
  {
    category: 'diag_sensors',
    test: 'accelerometer',
    id: '60'
  },
  {
    category: 'diag_sensors',
    test: 'lid_sensor',
    id: '90'
  },
  {
    category: 'diag_sensors',
    test: 'apple_lid_sensor',
    id: '97'
  },
  {
    category: 'diag_sensors',
    test: 'apple_ambient_light_sensor',
    id: '98'
  },
  {
    category: 'diag_sensors',
    test: 'apple_accelerometer_gyroscope_test',
    id: '99'
  },

  // STORAGE
  {
    category: 'diag_storage',
    test: 'hdd_short_smart_test',
    id: '10'
  },
  {
    category: 'diag_storage',
    test: 'hdd_long_smart_test',
    id: '11'
  },
  {
    category: 'diag_storage',
    test: 'hdd_linear_read_test',
    id: '12'
  },
  {
    category: 'diag_storage',
    test: 'hdd_random_read_test',
    id: '13'
  },
  {
    category: 'diag_storage',
    test: 'smart_attributes',
    id: '14'
  },
  {
    category: 'diag_storage',
    test: 'hdd_smart_status',
    id: '15'
  },
  {
    category: 'diag_storage',
    test: 'apple_storage_test',
    id: '19'
  },
  {
    category: 'diag_storage',
    test: 'optical_drive_read_test',
    id: '40'
  },
  

  // USER INPUTS
  {
    category: 'diag_user_inputs',
    test: 'keyboard',
    id: '30'
  },
  {
    category: 'diag_user_inputs',
    test: 'keyboard_status_led',
    id: '31'
  },
  {
    category: 'diag_user_inputs',
    test: 'apple_keyboard_test',
    id: '37'
  },
  {
    category: 'diag_user_inputs',
    test: 'apple_touch_id_test',
    id: '38'
  },
  {
    category: 'diag_user_inputs',
    test: 'apple_touch_bar_test',
    id: '39'
  },
  {
    category: 'diag_user_inputs',
    test: 'mouse_test',
    id: '130'
  },
  {
    category: 'diag_user_inputs',
    test: 'touchpad',
    id: '131'
  },
  {
    category: 'diag_battery',
    test: 'apple_trackpad_test',
    id: '132'
  },
  {
    category: 'diag_user_inputs',
    test: 'trackpoint',
    id: '133'
  },

  // VIDEO ADAPTER
  {
    category: 'diag_video_adapter',
    test: '2d_local_video_memory',
    id: '521'
  },
  {
    category: 'diag_video_adapter',
    test: '2d_all_available_memory',
    id: '522'
  },
  {
    category: 'diag_video_adapter',
    test: '2d_lines_and_bitmaps',
    id: '523'
  },
  {
    category: 'diag_video_adapter',
    test: '2d_emc_scrolling_characters',
    id: '524'
  },
  {
    category: 'diag_video_adapter',
    test: '2d_emc_reference_test_pattern',
    id: '525'
  },
  {
    category: 'diag_video_adapter',
    test: '3d',
    id: '526'
  },
  {
    category: 'diag_video_adapter',
    test: 'advanced_GPU_test',
    id: '527'
  },
  {
    category: 'diag_video_adapter',
    test: 'gpgpu',
    id: '528'
  },
  {
    category: 'diag_video_adapter',
    test: 'apple_gpu_test',
    id: '539'
  }
]

